import { Logger } from './Logger';

// https://firebase.google.com/docs/auth/admin/errors
// https://firebase.google.com/docs/reference/js/firebase.auth.Error for js-specific codes
const mappedErrors = {
  'auth/user-not-found': 'The user does not exist',
  'auth/email-already-exists': 'A user with this email already exists',
  'auth/wrong-password': 'The password you have entered is incorrect',
  'auth/too-many-requests': 'The password you have entered is incorrect. Use Forgot Password to reset it',  // happens after multiple invalid password attempts
  'auth/internal-error': 'Something went wrong',
  'auth/user-cancelled': 'Authentication was cancelled',
  'auth/unknown': 'Something went wrong',
};

const wrapError = (error) => {
  const message = mappedErrors[error.code];
  if (message) {
    return new Error(message);
  }

  // Notify if unmapped error message
  console.warn(`[AUTH] unmapped firebase error ${error.code}/${error.message}`);
  Logger.notify(new Error(error), (report) => {
    report.errorClass = 'UNMAPPED FIREBASE ERROR';
    report.errorMessage = `${error.code}`;
  });

  return new Error(error.message);
};

const firebaseErrorHandler = error => wrapError(error);

export default firebaseErrorHandler;
